import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import ChangeSocialUsername from '../../features/auth/components/changeSocialUsername';
import { FromSocial } from '../../features/auth/model/const';

const ChangeSocialUsernamePage = () => {
  const location: {
    state: FromSocial;
  } = useLocation();
  const fromSocial = location.state.from;
  const history = useHistory();

  if (!fromSocial) history.push(MAIN_ROUTES.login);

  return <ChangeSocialUsername title={`sign_up_with_${fromSocial}`} />;
};

export default ChangeSocialUsernamePage;
